<div *ngIf="summary" class="row summary px-3 py-4 m-0 position-relative" [ngClass]="['summary-' + summary.accountStatus.code, summary.isOnStop ? 'summary-isOnStop' : '']">

    <div *ngIf="isBusy && !silentLoading" class="row loading-overlay w-100 h-100 position-absolute align-items-center">
        <div class="col-lg-12 text-center mb-3">
            <lib-loading [status]="'text-white'" [spinnerPosition]="true" [text]="'LDG'" [size]="'md'">
            </lib-loading>
        </div>
    </div>

    <div class="col-12">
        <div class="row mb-2">
            <div class="col-md-12">
                <h1>{{ summary.accountName }}</h1>
            </div>
        </div>
    </div>
    <div class="col-md-4">
        
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Account Status:</span></div>
            <div class="col-md-8" *ngIf="summary.accountStatus">
                <span class="badge"
                [ngClass]="'badge-' + summary.accountStatus.code">{{ summary.accountStatus.name }}</span>
                <span *ngIf="summary.isOnStop" class="badge badge-isOnStop ml-2">On Stop</span>
            </div>
        </div>
        <div class="row mb-2" *ngIf="summary.customerType?.code == 'BUS'">
            <div class="col-md-4"><span class="text-muted">Company Name:</span></div>
            <div class="col-md-8" *ngIf="summary.companyName">{{ summary.companyName }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Account Number:</span></div>
            <div class="col-md-8">{{ summary.accountNumber }}</div>
        </div>
        <div class="row mb-2" *ngIf="summary.legacyInfo">
            <div class="col-md-4"><span class="text-muted">Branch Account Number:</span></div>
            <div class="col-md-8">
                <div *ngIf="summary.legacyInfo.accountNo_SNG"><span class="text-muted">UK:</span> {{ summary.legacyInfo.accountNo_SNG }}</div>
                <div *ngIf="summary.legacyInfo.accountNo_BAU"><span class="text-muted">US:</span> {{ summary.legacyInfo.accountNo_BAU }}</div>
                <div *ngIf="summary.legacyInfo.accountNo_SNH"><span class="text-muted">NL:</span> {{ summary.legacyInfo.accountNo_SNH }}</div>
                <div *ngIf="summary.legacyInfo.accountNo_SNF"><span class="text-muted">FR:</span> {{ summary.legacyInfo.accountNo_SNF }}</div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Customer Type:</span></div>
            <div class="col-md-8" *ngIf="summary.customerType">{{ summary.customerType.name }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Customer Group:</span></div>
            <div class="col-md-8" *ngIf="summary.customerGroup">{{ summary.customerGroup.name }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Discount Level:</span></div>
            <div class="col-md-8" *ngIf="summary.discountLevel">{{ summary.discountLevel.name }}</div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Default Contact:</span></div>
            <div class="col-md-8" *ngIf="summary.defaultContact">
                <div>{{ summary.defaultContact.fullName }}</div>
                <div *ngIf="summary.defaultContact.telephoneNumber">T: {{ summary.defaultContact.telephoneNumber }}</div>
                <div *ngIf="summary.defaultContact.mobileNumber">M: {{ summary.defaultContact.mobileNumber }}</div>
                <div *ngIf="summary.defaultContact.emailAddress"><a [href]="'mailto:' + summary.defaultContact.emailAddress">{{summary.defaultContact.emailAddress}}</a></div>
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Payment Method:</span></div>
            <div class="col-md-8" *ngIf="summary.paymentMethod">{{ summary.paymentMethod.name }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Shipping Method:</span></div>
            <div class="col-md-8" *ngIf="summary.defaultShippingMethodId">{{getShippingMethodTitle() | async}}</div>
        </div>
    </div>
    <div class="col-md-4">
        <div class="row mb-2">
            <div class="col-md-4"><span class="text-muted">Default Address:</span></div>
            <div class="col-md-8" *ngIf="summary.defaultAddress">
                <div>{{ summary.defaultAddress.details.name | titlecase }}</div>
                <div>{{ summary.defaultAddress.details.addressLine1 | titlecase }}</div>
                <div>{{ summary.defaultAddress.details.addressLine2 | titlecase }}</div>
                <div>{{ summary.defaultAddress.details.townCity | titlecase }}</div>
                <div>{{ summary.defaultAddress.details.countyState | titlecase }}</div>
                <div>{{ summary.defaultAddress.details.postalCode | uppercase }}</div>
                <div>{{ summary.defaultAddress.details.countryName | titlecase }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4"><span class="text-muted">Default Vehicle:</span></div>
            <div class="col-md-8" *ngIf="summary.defaultVehicle">{{summary.defaultVehicle.vehicleTitle}}</div>
        </div>
    </div>
    <div class="col-12">
        <div class="row mb-2">
            <div class="col-md-12">
                <p *ngIf="summary.internalComment" class="large-italic mt-3">
                    <span class="text-muted">Internal Comment:</span> {{summary.internalComment}}
                </p>          
            </div>
        </div>
    </div>
</div>